import React, { useState } from "react";
import { useLocation } from "react-router-dom";
import Sidebar from "./Sidebar.jsx";
import Header from "./Header.jsx";
import RaiseTicketModal from "../Support/RaiseTicketModal.jsx";

const Layout = ({ children, userType }) => {
  const [isTicketModalOpen, setIsTicketModalOpen] = useState(false);
  const location = useLocation();
  const hideSidebar = location.pathname.startsWith("/job-seeker/take-test");
  const isSubscriptionPage = location.pathname.includes("/subscription");

  return (
    <div className="flex min-h-screen bg-neutral-100 text-neutral-800 w-full overflow-x-hidden relative">
      {!hideSidebar && (
        <Sidebar 
          userType={userType} 
          onOpenTicketModal={() => setIsTicketModalOpen(true)}
        />
      )}
      <div className={`flex flex-1 flex-col min-w-0 overflow-x-hidden ${hideSidebar ? "ml-0" : "ml-16"}`}>
        <Header userType={userType} />
        <main className="flex-1 overflow-y-auto overflow-x-hidden bg-neutral-100 px-4 sm:px-6 lg:px-8 py-6">
          <div className={`${isSubscriptionPage ? "w-full" : "mx-auto max-w-[1280px] w-full"} space-y-6`}>
            {children}
          </div>
        </main>
      </div>

      {/* Raise Ticket Modal - Rendered at Layout level to cover entire page */}
      <RaiseTicketModal
        isOpen={isTicketModalOpen}
        onClose={() => setIsTicketModalOpen(false)}
        initialType="general"
        userType={userType}
      />
    </div>
  );
};

export default Layout;

